export default "__VITE_ASSET__1ef4c1af__"